export const API_PATH = {
  agreements: "by_agreements",
  members: "by_members"
};

export const MODULE_LOGICS = {
  AGREEMENTS: "agreements",
  MEMBERS: "members"
};
